import type { NoteWorkflowsDocument, WorkflowNodeSelection } from "../../components/NoteWorkflows/noteWorkflowsTypes";
import type { BuilderWorkflow, WorkflowBox } from "./models";

export const BUILDER_TRIGGER_NODE_ID = "entry";

export function builderBoxNodeId(boxId: string): string {
    return `box:${boxId}`;
}

/** Adapt the draft for the existing canvas without adding an output box to it. */
export function builderWorkflowDocument(workflow: BuilderWorkflow, draftId: string): NoteWorkflowsDocument {
    return {
        schema_version: 1,
        workflows: [
            {
                id: draftId, timezone: workflow.timezone, data_query: workflow.data_query, data_scope: workflow.data_scope,
                trigger: {
                    id: BUILDER_TRIGGER_NODE_ID,
                    title: workflow.title,
                    description: workflow.description
                },
                steps: workflow.boxes.map(box => ({
                    id: builderBoxNodeId(box.id),
                    title: box.title,
                    description: box.instructions,
                    context_selectors: [...box.context_selectors], analytics: box.analytics, client_brain_action: box.client_brain_action
                })),
                outcomes: []
            }
        ]
    };
}

export function getSelectedBuilderBox(
    workflow: BuilderWorkflow,
    draftId: string,
    selection: WorkflowNodeSelection | null
): WorkflowBox | undefined {
    if (!selection || selection.workflowId !== draftId || selection.nodeKind !== "step") {
        return undefined;
    }
    return workflow.boxes.find(box => builderBoxNodeId(box.id) === selection.nodeId);
}
